// Vue
import Vue from "vue";
import { mapGetters } from "vuex";

// Components
import { CartStepsHeader } from "@/components/Cart/CartStepsHeader";
import { formatDateTime, stringHelper } from "@/components/mixins";

// Types
import { CartStepName } from "../Types/";

export default Vue.extend({
  name: "CartContentWrapper",
  components: {
    CartStepsHeader,
  },
  mixins: [formatDateTime, stringHelper],
  computed: {
    ...mapGetters(["getContentItem"]),
  },
  props: {
    stepName: String,
    step: Number,
  },
  methods: {
    navigateToStep(stepName: CartStepName) {
      this.$emit("on-step-change", stepName);
    },
  }
});
